import { useEffect } from 'react';
import _throttle from 'lodash/throttle';
import { setLastActiveTime as _setLastActiveTime } from '@nbx/frontend-helpers/auth';

const setLastActiveTime = _throttle(_setLastActiveTime, 60 * 1000, {
  leading: false
});

export const useLastActiveTime = ({ accountId, platform }: { accountId: string; platform: string }) => {
  useEffect(() => {
    if (accountId && platform === 'web') {
      window.addEventListener('mousemove', setLastActiveTime);
      window.addEventListener('keydown', setLastActiveTime);
      window.addEventListener('touchstart', setLastActiveTime);
      window.addEventListener('touchmove', setLastActiveTime);
      return () => {
        setLastActiveTime.cancel();
        window.removeEventListener('mousemove', setLastActiveTime);
        window.removeEventListener('keydown', setLastActiveTime);
        window.removeEventListener('touchstart', setLastActiveTime);
        window.removeEventListener('touchmove', setLastActiveTime);
      };
    }
  }, [accountId, platform]);
};
